import * as coreClient from "@azure/core-client";

export const VoucherCodeApplyRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "VoucherCodeApplyRequest",
    modelProperties: {
      basketId: {
        serializedName: "basketId",
        required: true,
        type: {
          name: "String"
        }
      },
      voucherCode: {
        serializedName: "voucherCode",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const VoucherCodeApplyResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "VoucherCodeApplyResponse",
    modelProperties: {
      basketId: {
        serializedName: "basketId",
        required: true,
        type: {
          name: "String"
        }
      },
      basketItems: {
        serializedName: "basketItems",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "VoucherCodeBasketItem"
            }
          }
        }
      },
      discount: {
        serializedName: "discount",
        type: {
          name: "Composite",
          className: "BasketDiscount"
        }
      }
    }
  }
};

export const VoucherCodeBasketItem: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "VoucherCodeBasketItem",
    modelProperties: {
      ticketID: {
        serializedName: "ticketID",
        required: true,
        type: {
          name: "Number"
        }
      },
      ticketDescription: {
        serializedName: "ticketDescription",
        type: {
          name: "String"
        }
      },
      itemPrice: {
        serializedName: "itemPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      quantity: {
        serializedName: "quantity",
        required: true,
        type: {
          name: "Number"
        }
      },
      subTotalPrice: {
        serializedName: "subTotalPrice",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const BasketDiscount: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BasketDiscount",
    modelProperties: {
      voucherCode: {
        serializedName: "voucherCode",
        required: true,
        type: {
          name: "String"
        }
      },
      totalDiscountValue: {
        serializedName: "totalDiscountValue",
        required: true,
        type: {
          name: "Number"
        }
      },
      discountLabel: {
        serializedName: "discountLabel",
        required: true,
        type: {
          name: "String"
        }
      },
      accepted: {
        serializedName: "accepted",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "VoucherCodeDiscountAccepted"
            }
          }
        }
      },
      discountRejectedReason: {
        serializedName: "discountRejectedReason",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const VoucherCodeDiscountAccepted: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "VoucherCodeDiscountAccepted",
    modelProperties: {
      ticketID: {
        serializedName: "ticketID",
        required: true,
        type: {
          name: "Number"
        }
      },
      discountValue: {
        serializedName: "discountValue",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const ApiError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiError",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "Number"
        }
      },
      shortDescription: {
        serializedName: "shortDescription",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const VoucherCodeRemoveResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "VoucherCodeRemoveResponse",
    modelProperties: {
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const CustomerLoginNotificationResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomerLoginNotificationResponse",
    modelProperties: {
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      }
    }
  }
};
